import { usePlatformsSectionContent } from './usePlatformsSectionContent';
import { parsePlatformsAwaitsContent } from '../utils/platformsContent';

export const usePlatformsAwaitsContent = () =>
  usePlatformsSectionContent(parsePlatformsAwaitsContent);
